import { type ProductFilters } from '../types';

import { getYMALProductPrice } from './getYMALProductPrice';

import { type SimilarProduct } from '@/modules/similar/aliases';
import { getSizeNames } from '@/modules/similar/helpers/getSizeNames';

export function applyYMALProductFilters(
  products: SimilarProduct[],
  filters: ProductFilters,
  sizeIdToName?: Map<string, string>
): SimilarProduct[] {
  return products.filter((product) => {
    if (filters.sizes && filters.sizes?.length > 0) {
      const productSizes = getSizeNames(product.sizes);

      // Check if product matches any selected size filter
      const hasMatchingSize = filters.sizes.some((sizeFilter) => {
        // Try to get size name from composite ID map
        let sizeName = sizeIdToName?.get(sizeFilter);

        // If not found in map, treat the filter value as a plain size name (backward compatibility)
        if (!sizeName) {
          sizeName = sizeFilter;
        }

        // Check if product has this size
        const hasSizeName = productSizes.includes(sizeName);

        if (!hasSizeName) {
          return false;
        }

        return true;
      });

      if (!hasMatchingSize) {
        return false;
      }
    }

    if (filters.colours && filters.colours.length > 0) {
      const colourId = product.attributes?.colour?.[0];
      if (!colourId || !filters.colours.includes(colourId)) {
        return false;
      }
    }

    if (filters.onSale) {
      if (!product.pricing.is_reduced) {
        return false;
      }
    }

    if (filters.minPrice !== undefined || filters.maxPrice !== undefined) {
      const price = getYMALProductPrice(product.pricing);

      if (
        (filters.minPrice !== undefined && price < filters.minPrice) ||
        (filters.maxPrice !== undefined && price > filters.maxPrice)
      ) {
        return false;
      }
    }

    return true;
  });
}
